<p>
    <p-message severity="info" text="Click the Revoke Access button to revoke your access tokens and remove access to your QuickBooks Online Company files."></p-message>
</p>
<button title="Revoke Access" pButton type="button" (click)="RevokeAccessSubject.next()" label="Revoke Access"></button>
